export default __webpack_public_path__ + "static/media/dasboard.890c367d.svg";